// removed by extract-text-webpack-plugin
module.exports = {"background-grey":"#f6f6f6","light-grey":"#d4d4d4","form":"_31_O36sgKc9EtznjDO2dIN","groupLabel":"_3yfeiLUSPNWj2YDftKV9ev","inputsGroup":"_1DtPVrV4NV0tvFw8UKViwS","inputsWrapper":"_1eYngDDN3KgHwgEzaKmuET"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ShowCase/Controls/InputGroup/InputGroup.css
// module id = 865
// module chunks = 0